<script setup>
import { router } from "@inertiajs/vue3";
import { useAuthUser } from "@/composables/useAuthUser.js";
import BrandButton from "@/Components/Brand/BrandButton.vue";

/**
 * About page hero (GH-1145), rendered into SecondaryPageLayout's #hero slot.
 * A 350px band: below lg the standard linear gradient carries the copy alone;
 * from lg the Figma radial burst is centred on the gift mark of the collage
 * (flat Figma export, 605×350 @1x, two-backdrop matte), which scales to 75%
 * at lg so it clears the copy and runs full size from xl. The overlay circle
 * recreates the design's blend-mode glow over the gradient.
 */
const authUser = useAuthUser();

function getStarted() {
    router.get(route(authUser.value ? "dashboard" : "register"));
}
</script>

<template>
    <section
        class="relative flex min-h-[350px] items-center overflow-hidden border-t border-brand-tan/40 bg-gradient-to-r from-brand-red to-[#ffb545] lg:bg-[radial-gradient(548px_396px_at_calc(100%_-_293px)_161px,#ffb545_0%,#fc8c42_25%,#f9643f_50%,#f53c3c_75%,#f4283b_87.5%,#f21439_100%)] xl:bg-[radial-gradient(730px_528px_at_calc(100%_-_386px)_156px,#ffb545_0%,#fc8c42_25%,#f9643f_50%,#f53c3c_75%,#f4283b_87.5%,#f21439_100%)]"
    >
        <div
            aria-hidden="true"
            class="pointer-events-none absolute top-0 h-[350px] w-[605px] max-lg:hidden lg:right-[60px] lg:origin-right lg:scale-75 xl:right-[100px] xl:scale-100"
        >
            <div
                class="absolute left-[152px] top-[31px] size-[288px] rounded-full bg-[#fff3d9]/50 mix-blend-overlay"
            />
            <img
                :src="asset('images/brand/about-hero-collage.webp')"
                alt=""
                class="absolute inset-0 h-[350px] w-[605px] max-w-none"
            />
        </div>

        <div class="relative mx-auto w-full max-w-[983px] px-5 py-14 md:py-16">
            <h1
                class="font-brand-display text-[36px] font-black italic uppercase leading-[1.05] text-white md:text-[42px]"
            >
                The Best Wish List Ever™
            </h1>
            <p
                class="mb-0 mt-[14px] max-w-[359px] text-[16px] font-semibold leading-[1.3] text-[#ffe5bf]"
            >
                Gift Hero delivers a universal wish list that’s simple to
                navigate, aesthetically pleasing, and a re‑gifting squasher.
            </p>
            <!-- navyOnRed: the hover wipe goes white, not red, on the red band. -->
            <BrandButton
                variant="navyOnRed"
                class="mt-6 h-[52px] px-[27px] text-[15px]"
                @click="getStarted"
            >
                Get Started
            </BrandButton>
        </div>
    </section>
</template>
